import { useMutation } from '@tanstack/react-query';

import { prophetTypes } from '../types';
import { replaceMessagesWithUploadedFiles } from '../utils';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const addKeywordRule: prophetTypes.AddKeywordRule = async (data) => {
  const messagesWithUrls = await replaceMessagesWithUploadedFiles(data.messages, data.page._id);
  return axios.put(`/prophet/keyword-rules`, { ...data, messages: messagesWithUrls });
};

type AddKeywordRuleOptions = {
  pageId: string;
  config?: MutationConfig<typeof addKeywordRule>;
};

export function useAddKeywordRule({ config = {}, pageId }: AddKeywordRuleOptions) {
  return useMutation({
    ...config,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['keyword-rules', pageId]);
      toasts.loadingToast.success('add-keyword-rule');
      config.onSuccess?.(...args);
    },
    onError: (...args) => {
      toasts.loadingToast.error('add-keyword-rule');
      config.onError?.(...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('add-keyword-rule');
      config.onMutate?.(...args);
    },
    mutationFn: addKeywordRule,
  });
}
